import type { RichText } from "../../aysa_api/models/rich_text.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseRichText = (): RichText => {
  return {
    text: "",
  };
};

export const decodeRichText = (reader: Reader, length: number): RichText => {
  const end = reader.pos + length;
  const message = createBaseRichText();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.text = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeRichText = (writer: Writer, message: RichText): Writer => {
  writer.uint32(10).string(message.text);

  return writer;
};
